import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-treeview',
    templateUrl: './treeview.component.html',
    styleUrls: ['./treeview.component.scss'],
    imports: [CommonModule]
})
export class TreeviewComponent implements OnInit {
  @Input() title: string;
  constructor() {
    // This is intentional
   }

  ngOnInit() {
    // This is intentional
  }

}
